document.addEventListener('DOMContentLoaded', function () {
  function updateText(text){

  let delay = 200;
  
    var h1 = document.querySelector("#heatwaveBtn");
    //console.log("h1: ",h1);
  
        h1.innerHTML = text
          .split("")
          .map(letter => {
            //console.log(letter);
            return `<span>${letter}</span>`;
          })
          .join("");

        setTimeout(() => {
        Array.from(h1.children).forEach((span, index) => {
          setTimeout(() => {
            span.classList.add("wavy");
          }, (index * 60) + delay);
        });
        }, 200);
  
  }
  
  //document.getElementById('textField').addEventListener('input', (event)=>{
  //	updateText(event.target.value);
  //})
  updateText("Heatwave");
  function updateTextMobile(text){

  let delay = 200;
  
    var h1 = document.querySelector("#heatwaveBtnMobile");
    //console.log("h1: ",h1);
  
        h1.innerHTML = text
          .split("")
          .map(letter => {
            //console.log(letter);
            return `<span>${letter}</span>`;
          })
          .join("");

        setTimeout(() => {
          for (let i = 0; i < h1.children.length; i++) {
            setTimeout(() => {
              h1.children[i].classList.add("wavy");
            }, (i * 60) + delay);
          }
        }, 200);
  
  }
  
  //document.getElementById('textField').addEventListener('input', (event)=>{
  //	updateText(event.target.value);
  //})
  updateTextMobile("Heatwave");
});